import * as yup from 'yup';
import { z } from 'zod';

import parsePhoneNumber, { isValidNumberForRegion } from 'libphonenumber-js';
import {
    ENQUIRY_TYPE_BUYING_AND_SELLING_SHARES_VALUE,
    ENQUIRY_TYPE_INVESTING_WITH_FORSYTH_BARR_VALUE,
} from './EnquiryFormOptions';

import {
    ENQUIRY_TYPE_FIELD,
    INVESTMENT_METHOD_FIELD,
    NEAREST_LOCATION_FIELD,
    EMAIL_FIELD,
    FIRST_NAME_FIELD,
    INVESTED_BEFORE_FIELD,
    INVESTMENT_AMOUNT_FIELD,
    LAST_NAME_FIELD,
    PHONE_NUMBER_FIELD,
    PREFERRED_CONTACT_METHOD_FIELD,
} from './EnquiryFields';

const phoneNumberFormatValidation = (value) => {
    const phoneNumber = parsePhoneNumber(`+${value}`);

    if (!phoneNumber?.nationalNumber || !phoneNumber?.country) {
        return false;
    }

    return isValidNumberForRegion(phoneNumber?.nationalNumber, phoneNumber?.country);
};

const nonGeneralEnquiryValidation = (errorMessage) => yup.string()
    .when([ENQUIRY_TYPE_FIELD], {
        // eslint-disable-next-line max-len
        is: (value) => (value === ENQUIRY_TYPE_INVESTING_WITH_FORSYTH_BARR_VALUE || value === ENQUIRY_TYPE_BUYING_AND_SELLING_SHARES_VALUE),
        then: () => yup.string().required(errorMessage),
        otherwise: () => yup.string().notRequired(),
    });

const emailValidation = (email) => z.string().email().safeParse(email).success;

const validationSchema = yup.object({
    [ENQUIRY_TYPE_FIELD]: yup.string().required('Enquiry type is required'),
    [FIRST_NAME_FIELD]: yup.string().required('First name is required'),
    [LAST_NAME_FIELD]: yup.string().required('Last name is required'),
    [EMAIL_FIELD]: yup.string().required('Email address is required')
        .test('email-format', 'Please enter valid email address', emailValidation),
    [PHONE_NUMBER_FIELD]: yup.string().required('Phone number is required')
        .test('phone-format', 'Please enter valid phone number', phoneNumberFormatValidation),
    [PREFERRED_CONTACT_METHOD_FIELD]: yup.string().required('Preferred contact method is required'),
    [NEAREST_LOCATION_FIELD]: yup.string().required('Nearest branch is required'),
    [INVESTMENT_METHOD_FIELD]: nonGeneralEnquiryValidation('Investment method is required'),
    [INVESTED_BEFORE_FIELD]: nonGeneralEnquiryValidation('Invested before is required'),
    [INVESTMENT_AMOUNT_FIELD]: nonGeneralEnquiryValidation('Investment amount is required'),
});

export default validationSchema;
